import Catalog from "@/pages/Catalog";

export default function ThrustCatalog() {
  return (
    <Catalog
      collectionFilter="Thrust"
      overline="Thrust Line"
      titleLine1="Κατάλογος"
      titleAccent="Thrust."
      subtitle="Μηχανές της σειράς Thrust — επιλεγμένες, ρυθμισμένες, έτοιμες να πάρουν το δρόμο."
    />
  );
}
